import PNBLIcon from '../svg/PNBL.svg';

export default PNBLIcon;
